<template>
  <div>
    <v-row style="min-height: 68px">
      <v-col class="d-flex flex-1 align-center justify-space-between pb-5">
        <span class="header bold text-tcdc-green">
           <span v-if="lang == 'en' && article['subject_en'] == '' || article['subject_en'] == null">
            {{ article['subject_th'] }}
          </span>
           <span v-else-if="lang == 'th' && article['subject_th'] == '' || article['subject_th'] == null">
            {{ article['subject_en'] }}
          </span>
          <span v-else>
            {{ article[`subject_${lang}`] }}
          </span>
        </span>
        <ShareButton mode="article" :title="article[`subject_${lang}`]" :description="article[`intro_${lang}`]"></ShareButton>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col>
        <div class="d-flex flex-1 align-center">
          <div class="pr-3 d-flex align-center">
            <img src="../../assets/icons/sorts/calendar.png" class="eventdetail-card-logo mr-4" />
            <span class="bold text-uppercase text-tcdc-green">14 aug - 13 oct 2019</span>
          </div>
          <div class="d-flex align-center">
            <img src="../../assets/icons/marker.png" class="eventdetail-card-logo mr-4" />
            <span class="bold text-uppercase text-tcdc-green">TCDC BANGKOK</span>
          </div>
        </div>
      </v-col>
    </v-row>-->
    <v-row>
      <v-col>
        <span class="text-tcdc-grey1 color-grey1 bold mr-4">
          <span v-if="lang == 'en' && article['article_date_en'] == '' || article['article_date_en'] == null">
            {{ $t('article.publish') }} {{ article['article_date_th'] }}
          </span>
           <span v-else-if="lang == 'th' && article[`article_date_th`] == '' || article[`article_date_th`] == null">
            {{ $t('article.publish') }} {{ article['article_date_en'] }}
          </span>
          <span v-else>
            {{ $t('article.publish') }} {{ article[`article_date_${lang}`] }}
          </span>
        </span>

        <span class="text-tcdc-grey1 color-grey1 bold mr-4">|</span>
        <span
            class="text-tcdc-grey1 color-grey1 bold mr-4">{{
            $t('article.resource')
          }} :
          <span v-if="article">
              {{ article.original_resource_name}}
<!--            {{ article['organize_name_th'] }}-->
          </span>


        </span>
        <span class="text-tcdc-grey1 color-grey1 bold mr-4">|</span>
        <img alt="view" class="tcdc-view-icon mr-2" src="../../assets/icons/generals/view.png"/>
        <span class="text-tcdc-grey1 color-grey1 bold mr-4">{{ formatNumber(article.article_view) }}</span>
      </v-col>
    </v-row>
    <!-- section 1 -->
    <v-row class="mb-5">
      <v-col>
        <v-img eager :src="article.cover_img_path" aspect-ratio="1.7"></v-img>
        <!--        <ImageCarousel />-->
      </v-col>
    </v-row>
    <!--    <v-row>-->
    <!--      <v-col class="pt-0" >-->
    <!--        <div-->
    <!--          class="text-tcdc-green bold vhtml"-->
    <!--          v-html="article[`intro_${lang}`]"-->
    <!--        ></div>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <v-row class="mb-5">
      <v-col v-if="lang == 'en' && article[`detail_en`] == '' || article[`detail_en`] == null">
        <div class="vhtml" style="letter-spacing: .5px" v-html="article[`detail_th`]"></div>
      </v-col>
      <v-col v-else-if="lang == 'th' && article[`detail_th`] == '' || article[`detail_th`] == null ">
        <div class="vhtml" style="letter-spacing: .5px" v-html="article[`detail_en`]"></div>
      </v-col>
      <v-col v-else>
        <div class="vhtml" style="letter-spacing: .5px" v-html="article[`detail_${lang}`]"></div>
      </v-col>
    </v-row>

    <div>
      <span class="mr-3">TAGS:</span>
      <span
          class="mr-2 text-tcdc-green cursor-pointer"
          v-for="(tag, i) in article.tag"
          :key="i"
          @click="searchTag(tag.tag_name)"
      >#{{tag.tag_name}}</span>
    </div>

    <!-- section 2 -->
    <!--    <v-row>-->
    <!--      <v-col>-->
    <!--        <ImageCarousel />-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <!-- <v-row>
      <v-col>
        <span class="sub-header1">
          Grounded on the idea that design and
          creativity cannot exist withoutcultural foundation and intellectual accumulation of knowledge.
        </span>
      </v-col>
    </v-row>-->

    <!-- section relate article -->
    <!--    <v-row class="pt-8">-->
    <!--      <v-col>-->
    <!--        <span class="text-tcdc-green sub-header1 bold text-uppercase">related article</span>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <!--    <v-row class="d-flex flex-wrap">-->
    <!--      <template v-for="(item, index) of []">-->
    <!--        <v-col cols="12" md="6" :key="index">-->
    <!--          &lt;!&ndash; <EventCard-->
    <!--            class="cursor-pointer"-->
    <!--            :name="item.name"-->
    <!--            :time_start="item.start_date"-->
    <!--            :time_end="item.end_date"-->
    <!--            :place="item.place"-->
    <!--            @click.native="eventDetailHandler"-->
    <!--          />&ndash;&gt;-->
    <!--          <ArticleCard :border="false" />-->
    <!--        </v-col>-->
    <!--      </template>-->
    <!--    </v-row>-->
  </div>
</template>

<script>
import ShareButton from "../buttons/ShareButton";
import {mapState} from 'vuex';

export default {
  components: {
    // ArticleCard,
    // ImageCarousel,
    ShareButton
  },
  methods: {
    eventDetailHandler() {
      const eventId = 2;
      this.$router.push(`/${this.lang}` + `/events/${eventId}`);
    },
    formatNumber(num) {
      if (!num && num !== 0) return ''
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    searchTag (tag) {
      this.$router.push({ name: `TagSearch`, hash: '#'+tag });
    }
  },
  computed: {
    ...mapState({
      article: state => state.Article.article,
      tagName: state => state.Branch.tag_name,
      lang: state => state.Branch.lang
    })
  },
  mounted() {
    // console.log('xx',this.article)
  },
  beforeDestroy () {
    this.$store.commit('Article/clearArticle')
  }
}
</script>

<style scoped>
.eventdetail-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
